jQuery(document).ready(function onWhitepaperDownloadReady($) {
    "use strict";

    $('.whitepaper .gform_wrapper form').on('submit', onFormSubmit);

    function onFormSubmit(e) {
        $('.guide-form').hide();
        $('.whitepaper__thanks').show();
    }
});